module.exports = __webpack_public_path__ + "static/media/map-marker-with-key-pickup.7e6c9c9a.svg";